export const ROUTES = {
    HOME: '/',
    INSPECTION: '/inspection',
    LINE: '/inspection/:categoryName',
    LINE_DETAILS: '/inspection/:categoryName/:lineName',
    REVIEW: '/review',
    REPORT_MEDIA_LIBRARY: '/report_media_library',
    FALLBACK: '*',
    PINTURAEDITOR: '/pinturaeditor',
    MYREPORTS: '/report-status-page'
};

// The line/comment page scrolls inside this fixed-height box, never the window,
// so anything saving or restoring its scroll position has to address it directly.
export const LINE_DETAILS_SCROLL_CONTAINER_ID = "line_details_scroll_container";

// The category page (intro text + line list) scrolls inside its own box too.
export const CATEGORY_SCROLL_CONTAINER_ID = "category_scroll_container";

// Delay before restoring scroll/tab position on mount, long enough for the
// comment/line/intro-text sections above to have rendered so their DOM elements
// exist to scroll to (PALM-15231).
export const SCROLL_RESTORE_DELAY_MS = 100;

// Longest a restore keeps waiting for its target to render before it gives up
// and falls back. The PDF-template page loads its elements late, which is why
// its restore once waited a flat 3000ms; polling for the element instead means
// the common case is immediate and the slow case still works.
export const SCROLL_RESTORE_MAX_WAIT_MS = 3000;

// `clickedFrom` navigation-state value for links in the comment Move to / Copy to success toast
export const MOVE_COPY_TOAST_NAV_SOURCE = "moveCopyToast";

export const colors = {
    SCHEDULED: '#1F2F9C',
    SCHEDULED_BG: '#C7DBF6',
    IN_PROGRESS: '#CB8530',
    IN_PROGRESS_BG: '#FFF9C8',
    COMPLETE: '#5A1F9C',
    COMPLETE_BG: '#F1DDFF',
    PUBLISHED: '#1F9C7B',
    PUBLISHED_BG: '#C7F6E0',
    DRAFT: '#F35F01',
    DRAFT_BG: '#FFECD2',
    CANCLED: '#E30303',
    CANCLED_BG: '#FFD7D2',
    ERROR: '#611A15',
    ERROR_BG: '#fdeceb',
    ERROR_ICON: '#F44336',
};

